import {
  useCreateResource,
  useDeleteResource,
  useEditResource,
  usePaginatedResource,
  useResourceItem,
} from "./useCrudResource"

import {
  createLcDocument,
  deleteLcDocument,
  getLcDocument,
  getLcDocuments,
  updateLcDocument,
} from "api/lcDocumentApi"

export const LC_DOCUMENT_QUERY_KEY = "lc-documents"

export const useLcDocuments = (params = {}, enabled = true) =>
  usePaginatedResource(LC_DOCUMENT_QUERY_KEY, getLcDocuments, params, enabled)

export const useLcDocument = (id, enabled = true) =>
  useResourceItem(LC_DOCUMENT_QUERY_KEY, getLcDocument, id, enabled)

export const useCreateLcDocument = () =>
  useCreateResource(createLcDocument, LC_DOCUMENT_QUERY_KEY)

export const useEditLcDocument = () =>
  useEditResource(updateLcDocument, LC_DOCUMENT_QUERY_KEY)

export const useDeleteLcDocument = () =>
  useDeleteResource(deleteLcDocument, LC_DOCUMENT_QUERY_KEY)
